import { createSlice } from '@reduxjs/toolkit';

export interface IUiReducer {
  isMainOverflowAuto: boolean;
}

const initialState = {
  isMainOverflowAuto: true,
} as unknown as IUiReducer;

export const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setIsMainOverflowAuto: (state, action) => {
      state.isMainOverflowAuto = action.payload;
    },
  },
});

export const { setIsMainOverflowAuto } = uiSlice.actions;
